import React from 'react';

import i18n from '@components/i18n/i18n';
import { Button } from './Button.styles';
import loader from './images/loader.gif';
import { useSelector } from 'react-redux';

const content = {
  disabledButton: {
    en: 'Processing...',
    ar: 'جاري الأرسال…',
    zh: 'Processing...',
  },
};

const ButtonComponent = ({ text, disabled, dark = false, ...rest }) => {
  const { language: language } = useSelector(({ appState }) => appState);
  return (
    <Button
      {...rest}
      disabled={disabled}
      dark={!!dark}
      image={disabled ? loader : null}
    >
      {disabled ? content.disabledButton[language] : text}
    </Button>
  );
};

export default ButtonComponent;
